enum CustomEventType {
    IntegrationMetric = 'integrationMetric'
}

export { CustomEventType };
